/*global Routing*/

let suggestions = {
    clientAddressId: 'client_clientAddress',
    clientFiasAddressId: 'fias_address',
    clientCityId: 'client_city',
    suggestionBlockId: 'suggestions',
    //TODO BEGIN Пока не совсем ясно, зачем такое ограничение по FiasId
    // Если это всё же потребуется, нужно будет переделать на автоматическое получение FiasId из DaData
    // https://dadata.ru/api/find-fias/
    spbFiasId: 'c2deb16a-0330-4f05-821f-1d09c93331e6',
    loFiasId: '6d1ebb35-70c6-4129-bd55-da3969658f5d',
    mskFiasId: '0c5b2444-70a0-4932-980c-b4dc0d3f02b5',
    moFiasId: '29251dcf-00a1-4e34-98d4-5c47484a36d4',
    // TODO END
    locationBooster: '',
    fiasAddress: '',
    suggestions: {},
    timer: 0,
    selectedSuggestion: {},

    ready: function () {
        document.addEventListener('DOMContentLoaded', () => {
            this.processLocationBooster();
            this.processFiasAddress();
        })
    },

    processLocationBooster: function () {
        const clientCity = document.getElementById(this.clientCityId) || document.getElementById('new_' + this.clientCityId);
        if (clientCity !== null) {
            this.setLocationBooster(clientCity, true);
            clientCity.addEventListener('change', () => {
                this.setLocationBooster(clientCity, false);
            });
        }
    },

    getElementClientAddress: function () {
        return document.getElementById(this.clientAddressId) || document.getElementById('new_' + this.clientAddressId);
    },

    setLocationBooster: function (clientCity, initial) {
        const clientFiasAddress = document.getElementById(this.clientFiasAddressId);
        const clientAddress = this.getElementClientAddress();
        if (!initial) {
            clientFiasAddress.value = '';
            clientAddress.value = JSON.stringify([]);
            this.selectedSuggestion = {};
            this.setFiasAddress(clientFiasAddress);
        }

        if (clientCity.selectedIndex > 0) {
            const city = clientCity[clientCity.selectedIndex].innerText;
            clientFiasAddress.removeAttribute('readonly');

            //TODO BEGIN Пока не совсем ясно, зачем такое ограничение по FiasId
            // Если это всё же потребуется, нужно будет переделать на автоматическое получение FiasId из DaData
            // https://dadata.ru/api/find-fias/
            //
            // if (city == 'Санкт-Петербург') {
            //     this.locationBooster = [
            //         {
            //             region_fias_id: this.spbFiasId
            //         },
            //         {
            //             region_fias_id: this.loFiasId
            //         }
            //     ];
            //     clientFiasAddress.removeAttribute('readonly');
            // } else if (city == 'Москва') {
            //     this.locationBooster = [
            //         {
            //             region_fias_id: this.mskFiasId
            //         },
            //         {
            //             region_fias_id: this.moFiasId
            //         }
            //     ];
            //     clientFiasAddress.removeAttribute('readonly');
            // } else {
            //     this.locationBooster = '';
            //     clientFiasAddress.setAttribute('readonly', 'true');
            // }
            // TODO END
        } else {
            this.locationBooster = '';
            clientFiasAddress.setAttribute('readonly', 'true');
        }
    },

    processFiasAddress: function () {
        const clientFiasAddress = document.getElementById(this.clientFiasAddressId);
        if (clientFiasAddress !== null) {
            this.setFiasAddress(clientFiasAddress);
            clientFiasAddress.addEventListener('keydown', (event) => {

                this.selectedSuggestion = {};
                const clientAddress = this.getElementClientAddress();
                clientAddress.value = JSON.stringify([]);

                if (event.key === 'ArrowUp') {
                    event.preventDefault();
                    this.suggestionUp();
                } else if (event.key === 'ArrowDown') {
                    event.preventDefault();
                    this.suggestionDown();
                } else if (event.key === 'Enter') {
                    event.preventDefault();
                    this.suggestionEnter();
                } else if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
                    this.setFiasAddress(clientFiasAddress);

                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                        this.setSuggestions(event.target.value);
                    }, 500);
                }
            });

            clientFiasAddress.addEventListener('focusout', (event) => {
                if (event.relatedTarget !== null && event.relatedTarget.dataset.index) {
                    return;
                }
                const suggestionBlock = document.getElementById(this.suggestionBlockId);
                suggestionBlock.classList.remove('active');
            });
        }
    },

    suggestionUp: function () {
        let suggestionElements = document.getElementsByClassName('suggestion');
        let activeSuggestionElements = document.getElementsByClassName('suggestion active');
        suggestionElements = Array.from(suggestionElements);
        activeSuggestionElements = Array.from(activeSuggestionElements);
        if (suggestionElements.length) {
            let index = 0;
            if (!activeSuggestionElements.length) {
                suggestionElements[suggestionElements.length - 1].classList.add('active');
            } else {
                index = activeSuggestionElements[0].dataset.index;
                suggestionElements[index].classList.remove('active');
                if (+index - 1 < 0) {
                    suggestionElements[suggestionElements.length - 1].classList.add('active');
                } else {
                    suggestionElements[+index - 1].classList.add('active');
                }
            }
        }
    },

    suggestionDown: function () {
        let suggestionElements = document.getElementsByClassName('suggestion');
        let activeSuggestionElements = document.getElementsByClassName('suggestion active');
        suggestionElements = Array.from(suggestionElements);
        activeSuggestionElements = Array.from(activeSuggestionElements);
        if (suggestionElements.length) {
            let index = 0;
            if (!activeSuggestionElements.length) {
                suggestionElements[0].classList.add('active');
            } else {
                index = activeSuggestionElements[0].dataset.index;
                suggestionElements[index].classList.remove('active');
                if (+index + 1 > suggestionElements.length - 1) {
                    suggestionElements[0].classList.add('active');
                } else {
                    suggestionElements[+index + 1].classList.add('active');
                }
            }
        }
    },

    suggestionEnter: function () {
        let activeSuggestionElements = document.getElementsByClassName('suggestion active');
        activeSuggestionElements = Array.from(activeSuggestionElements);
        if (activeSuggestionElements.length) {
            const index = activeSuggestionElements[0].dataset.index;

            const suggestionBlock = document.getElementById(this.suggestionBlockId);
            const clientFiasAddress = document.getElementById(this.clientFiasAddressId);
            clientFiasAddress.value = this.suggestions[index].value;
            suggestionBlock.classList.remove('active');
            this.setFiasAddress(clientFiasAddress);
            this.setSelectedSuggestion(this.suggestions[index]);
        }
    },

    setFiasAddress: function (clientFiasAddress) {
        this.fiasAddress = clientFiasAddress.value;
    },

    setSelectedSuggestion: function (suggestion) {
        this.selectedSuggestion = suggestion;
        const clientAddress = this.getElementClientAddress();
        const prevAddress = JSON.parse(clientAddress.value);
        clientAddress.value = JSON.stringify({
            id: prevAddress.id,
            address: suggestion.value,
            ...suggestion.data
        });
        this.checkAddress();
    },

    checkAddress: function () {
        if (this.selectedSuggestion.data.house === null) {
            this.setSuggestions();
        }
    },

    setSuggestions: function (value) {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', Routing.generate(`api.client.address.suggestion`));
        xhr.send(JSON.stringify({
            query: value,
            count: 6,
            locations: this.locationBooster
        }));

        xhr.onreadystatechange = () => {
            if (!xhr || xhr.readyState != 4) {
                return;
            }

            if (xhr.status == 200) {
                const response = JSON.parse(xhr.response);
                this.suggestions = response.suggestions;
                this.addSuggestionsBlock();
            }
        }
    },

    addSuggestionsBlock: function () {
        const clickHandler = (event) => {
            const clientFiasAddress = document.getElementById(this.clientFiasAddressId);
            const suggestionBlock = document.getElementById(this.suggestionBlockId);
            clientFiasAddress.value = event.target.innerText;
            suggestionBlock.classList.remove('active');
            const index = event.target.dataset.index;
            this.setFiasAddress(clientFiasAddress);
            this.setSelectedSuggestion(this.suggestions[index]);
        };

        let suggestionBlockHTML = '<ul></ul>';
        let suggestionElements = document.getElementsByClassName('suggestion');
        suggestionElements = Array.from(suggestionElements);
        if (suggestionElements.length > 0) {
            suggestionElements.forEach((elem) => {
                elem.removeEventListener('click', clickHandler);
            });
        }

        if (this.suggestions.length) {
            suggestionBlockHTML = '<ul>';
            this.suggestions.forEach((suggestion, index) => {
                suggestionBlockHTML += `<li class="suggestion" tabindex="-1" data-index="${index}">${suggestion.value}</li>`;
            });
            suggestionBlockHTML += '</ul>';
        }

        const suggestionBlock = document.getElementById(this.suggestionBlockId);
        suggestionBlock.classList.add('active');
        suggestionBlock.innerHTML = suggestionBlockHTML;

        suggestionElements = document.getElementsByClassName('suggestion');
        suggestionElements = Array.from(suggestionElements);
        if (suggestionElements.length > 0) {
            suggestionElements.forEach((elem) => {
                elem.addEventListener('click', clickHandler);
            });
        }

        this.selectedSuggestion = {};
    },
};

suggestions.ready();